module.exports = __webpack_public_path__ + "static/media/html.f2282f94.png";